export function dateNow() {
    return Date.now();
}
//# sourceMappingURL=date.js.map